module.exports = __webpack_public_path__ + "static/media/img-logo-PV.889cf11b.png";